import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

import { COMPONENTS } from "./components";
import { BlogRoutingModule } from "./blog-routing.module";

@NgModule({
    providers: [],
    exports: [...COMPONENTS],
    imports: [CommonModule, BlogRoutingModule, ...COMPONENTS],
})
export class BlogModule {
  static forRoot(): ModuleWithProviders<BlogModule> {
    return {
      ngModule: BlogModule,
      providers: [],
    };
  }
}
